module.exports = __webpack_public_path__ + "DINNextLTPro-HeavyItalic.ttf?030f3ec6b05fbf6ec21b44dcdfb9b6c6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-HeavyItalic.ttf
// module id = 1414
// module chunks = 0